import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const IntercityIcon = ({ ...otherProps }) => {
  return (
    <SvgIcon
      sx={{ height: '40px', width: '40px', fill: 'none' }}
      viewBox="0 0 40 40"
      {...otherProps}
    >
      <circle cx="20" cy="20" r="20" fill="#24428A" />
      <path
        d="M22.7583 26.75C21.9583 27.5833 21.0416 28.4417 19.9999 29.3333C15.5583 25.5417 13.3333 22.2667 13.3333 19.5C13.3333 15.35 16.4999 12.6667 19.9999 12.6667C23.3333 12.6667 26.3666 15.1 26.6416 18.9167H29.5833L25.8333 22.6667L22.0833 18.9167H24.9749C24.7083 16.2 22.6083 14.3333 19.9999 14.3333C17.2083 14.3333 14.9999 16.475 14.9999 19.5C14.9999 21.45 16.6249 24.0333 19.9999 27.1167C20.5333 26.625 21.0249 26.15 21.4749 25.6917C21.3283 25.4023 21.2512 25.0827 21.2499 24.7583C21.2499 24.2058 21.4694 23.6759 21.8601 23.2852C22.2508 22.8945 22.7807 22.675 23.3333 22.675C23.8858 22.675 24.4157 22.8945 24.8064 23.2852C25.1971 23.6759 25.4166 24.2058 25.4166 24.7583C25.4163 25.0806 25.341 25.3983 25.1967 25.6865C25.0524 25.9746 24.843 26.2252 24.5851 26.4184C24.3272 26.6116 24.0279 26.7422 23.7108 26.7997C23.3937 26.8573 23.0676 26.8403 22.7583 26.75Z"
        fill="#FFCD59"
      />
    </SvgIcon>
  )
}

export default IntercityIcon
